// @flow

import React from 'react';
import type { Node } from 'react';
import { connect } from 'react-redux';
import ColumnContainer from './column.container';
import type {
  ACFComponentColumn,
  ACFTabsColumn,
  ACFRowTemplate,
  ACFCut,
} from '../../types';
import Card from '../card';
import type { BreakpointData } from '../row/types';
import { getPdbIds } from '../../store/pdb/selectors';

type StateProps = {|
  pdbIds?: Array<string>,
|};

type OwnProps = {|
  column: ?(ACFComponentColumn | ACFTabsColumn),
  responsiveData: BreakpointData,
  rowTemplate: ACFRowTemplate,
  cut: ACFCut,
  index: number,
  slideshow?: boolean,
  className?: string,
  children: Node,
|};

type Props = {|
  ...StateProps,
  ...OwnProps,
|};

const ACFColumn = ({
  column,
  responsiveData,
  rowTemplate,
  cut,
  index,
  slideshow,
  className,
  children,
  pdbIds,
}: Props) => {
  if (!column
      || (column.components
          && column.components[0].pdb_id
          && (pdbIds || []).length >= 1
          && !(pdbIds || []).includes(column.components[0].pdb_id))) {
    return null;
  }

  const {
    background_color,
    vertical_align,
    use_image,
    image,
    position_vertical,
    position_horizontal,
    components_over_cut,
  } = column;

  const columnImage = use_image && image ? {
    use_image,
    image,
    position_vertical,
    position_horizontal,
  } : null;

  return (
    <ColumnContainer
      className={className} // gets styling from row.styled and rowCut
      backgroundColor={background_color}
      rowTemplate={rowTemplate}
      index={index}
      responsiveData={responsiveData}
      cut={cut}
      image={columnImage}
      verticalAlign={vertical_align}
      slideshow={slideshow}
      componentsOverCut={components_over_cut}
    >
      {(column.has_tabs === false && column.is_boxed) ? (
        <Card
          backgroundColor={column.boxed_background_color}
          variant={column.boxed_variant}
          spread={vertical_align === 'spread'}
        >
          {children}
        </Card>
      ) : children}
    </ColumnContainer>
  );
};

ACFColumn.defaultProps = {
  slideshow: false,
  className: '',
  pdbIds: [],
};

const mapStateToProps = (state, ownProps) => ({
  pdbIds: ownProps.column
    && ownProps.column.components
    && ownProps.column.components[0].pdb_id
    && getPdbIds(state),
});

export default connect(mapStateToProps)(ACFColumn);
